export * from './legal.component';
export * from './legal.route';
export * from './legal.module';



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/legal/index.ts